"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _spauiUtils = require("@tencent/spaui-utils");

var _info = _interopRequireDefault(require("./info"));

var _tabs_props = require("./tabs_props");

var _tab_panel = _interopRequireDefault(require("./tab_panel"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * @class
 */
var Tabs =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Tabs, _PureComponent);

  function Tabs(props) {
    var _this;

    _classCallCheck(this, Tabs);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Tabs).call(this, props));

    _this.nullList();

    _this.active = {};
    _this.setSliderPositionTimeoutInstance = null;
    _this.hasSetSliderPositionTimeout = false;
    return _this;
  }

  _createClass(Tabs, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setSliderPositionAsync();

      if ((0, _spauiUtils.isFunction)(_spauiUtils.checkCssVersion)) {
        (0, _spauiUtils.checkCssVersion)(_info["default"]);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.setSliderPositionAsync();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this2 = this;

      var result = this.getPanel(); // 存储的一些引用释放

      result.map(function () {
        var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var _item$props = item.props,
            props = _item$props === void 0 ? {} : _item$props;
        var name = props.name;

        if (typeof name !== 'undefined') {
          _this2["".concat(name, "_dom")] = null;
        }

        return item;
      });
      this.nullList();
    } // 声明以及一些引用的回收

  }, {
    key: "nullList",
    value: function nullList() {
      this.slider = null;
      this.buttonWrap = null;
    } // 用于向实例提供内部node的节点引用

  }, {
    key: "getNode",
    value: function getNode() {
      return {
        slider: this.slider || null,
        buttonWrap: this.buttonWrap || null
      };
    } // 设置slider的位置

  }, {
    key: "setSliderPosition",
    value: function setSliderPosition() {
      var _this3 = this;

      var _this$props = this.props,
          value = _this$props.value,
          _this$props$sliderTop = _this$props.sliderTopIsAdjust,
          sliderTopIsAdjust = _this$props$sliderTop === void 0 ? true : _this$props$sliderTop;
      var sliderRect = {};
      var buttonWrapRect = {};
      var buttonDom = null;
      var buttonRect = {};

      if (this.slider && this.buttonWrap && typeof value !== 'undefined' && this["".concat(value, "_dom")]) {
        buttonDom = this["".concat(value, "_dom")].getElementsByTagName('a');

        if (buttonDom && buttonDom.length > 0 && buttonDom[0]) {
          buttonWrapRect = this.buttonWrap.getBoundingClientRect();
          sliderRect = this.slider.getBoundingClientRect();
          buttonRect = buttonDom[0].getBoundingClientRect();
          this.slider.style.left = "".concat(buttonRect.left - buttonWrapRect.left + (buttonRect.width - (sliderRect.width || 12)) / 2, "px");

          if (sliderTopIsAdjust) {
            this.slider.style.top = "".concat(buttonRect.top - buttonWrapRect.top + buttonRect.height - sliderRect.height - 1, "px");
          }

          if (this.slider.style.visibility === 'hidden') {
            // 如果一开始是隐藏的，避免出现一开始就有动画，延迟下展示
            setTimeout(function () {
              if (_this3.slider) {
                _this3.slider.style.visibility = 'visible';
              }
            }, 250);
          } else {
            this.slider.style.visibility = 'visible';
          }
        }
      }
    } // 延时一点设置slider的位置

  }, {
    key: "setSliderPositionAsync",
    value: function setSliderPositionAsync() {
      var _this4 = this;

      var _this$props$setSlider = this.props.setSliderPositionTimeout,
          setSliderPositionTimeout = _this$props$setSlider === void 0 ? 0 : _this$props$setSlider;

      if (setSliderPositionTimeout < 1) {
        this.hasSetSliderPositionTimeout = false;
      }

      if (setSliderPositionTimeout > 0 && !this.hasSetSliderPositionTimeout) {
        clearTimeout(this.setSliderPositionTimeoutInstance);
        this.setSliderPositionTimeoutInstance = setTimeout(function () {
          _this4.setSliderPosition();

          _this4.hasSetSliderPositionTimeout = true;
        }, setSliderPositionTimeout);
      } else if (window.requestAnimationFrame) {
        window.requestAnimationFrame(function () {
          _this4.setSliderPosition();
        });
      } else {
        clearTimeout(this.setSliderPositionTimeoutInstance);
        this.setSliderPositionTimeoutInstance = setTimeout(function () {
          _this4.setSliderPosition();
        }, 16);
      }
    }
    /**
     * 从children里面筛选只能是Column的子节点作为新的children
     */

  }, {
    key: "getPanel",
    value: function getPanel() {
      var _this$props2 = this.props,
          _this$props2$children = _this$props2.children,
          children = _this$props2$children === void 0 ? null : _this$props2$children,
          data = _this$props2.data;

      var filter = function filter() {
        var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        var isOk = false;

        if (item) {
          var _item$type = item.type,
              type = _item$type === void 0 ? null : _item$type,
              _item$props2 = item.props,
              props = _item$props2 === void 0 ? {} : _item$props2;
          var tab = props.tab,
              name = props.name,
              _props$isTabCommon = props.isTabCommon,
              isTabCommon = _props$isTabCommon === void 0 ? false : _props$isTabCommon;

          if (type && !isTabCommon && (typeof tab === 'undefined' || tab) && typeof name !== 'undefined') {
            isOk = true;
          }
        }

        return isOk;
      };

      var result = [];

      if ((0, _spauiUtils.isArray)(data)) {
        data.forEach(function (item) {
          var elementItem = null;

          if (_typeof(item) === 'object' && item) {
            var _item$label = item.label,
                label = _item$label === void 0 ? '' : _item$label,
                _item$value = item.value,
                value = _item$value === void 0 ? '' : _item$value,
                _item$children = item.children,
                _children = _item$children === void 0 ? null : _item$children,
                otherProps = _objectWithoutProperties(item, ["label", "value", "children"]);

            elementItem = _react["default"].createElement(_tab_panel["default"], _extends({
              tab: label,
              name: value
            }, otherProps), _children);

            if (filter(elementItem)) {
              result.push(elementItem);
            }
          }
        });
      } else if ((0, _spauiUtils.isArray)(children)) {
        children.map(function () {
          var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

          if ((0, _spauiUtils.isArray)(item)) {
            item.forEach(function (subItem) {
              if (filter(subItem)) {
                result.push(subItem);
              }
            });
          } else if (filter(item)) {
            result.push(item);
          }

          return item;
        });
      } else if (filter(children)) {
        result.push(children);
      }

      return result;
    } // 获取按钮的结构

  }, {
    key: "getButtons",
    value: function getButtons(className) {
      var _this5 = this;

      var panels = this.getPanel();
      var _this$props3 = this.props,
          propsValue = _this$props3.value,
          needSlider = _this$props3.needSlider,
          _this$props3$disabled = _this$props3.disabled,
          disabled = _this$props3$disabled === void 0 ? false : _this$props3$disabled,
          LinkComponent = _this$props3.LinkComponent,
          stacked = _this$props3.stacked,
          onChange = _this$props3.onChange,
          _this$props3$addon = _this$props3.addon,
          addon = _this$props3$addon === void 0 ? null : _this$props3$addon,
          textSize = _this$props3.textSize,
          textType = _this$props3.textType,
          buttonClassName = _this$props3.buttonClassName,
          buttonActiveClassName = _this$props3.buttonActiveClassName;
      var value = propsValue;
      return _react["default"].createElement("ul", {
        className: className,
        ref: function ref(el) {
          _this5.buttonWrap = el;
        }
      }, panels.map(function (item, index) {
        var _item$props3 = item.props,
            props = _item$props3 === void 0 ? {} : _item$props3;
        var tab = props.tab,
            name = props.name,
            _props$disabled = props.disabled,
            itemDisabled = _props$disabled === void 0 ? false : _props$disabled,
            _props$unChange = props.unChange,
            unChange = _props$unChange === void 0 ? false : _props$unChange,
            _onClick = props.onClick,
            _props$hide = props.hide,
            hide = _props$hide === void 0 ? false : _props$hide,
            _props$className = props.className,
            className = _props$className === void 0 ? '' : _props$className;

        var _disabled = disabled || itemDisabled || false;

        var style = {}; // 如果指明了hide就隐藏下

        if (hide) {
          style.display = 'none';
        }

        var active = value === name;
        return _react["default"].createElement("li", {
          key: index,
          className: (0, _classnames["default"])(className, {
            active: active,
            disabled: _disabled
          }),
          ref: function ref(el) {
            _this5["".concat(name, "_dom")] = el;
          },
          style: style
        }, _react["default"].createElement(LinkComponent, _extends({}, props, {
          value: name,
          active: active,
          textSize: textSize,
          textType: textType,
          disabled: _disabled,
          buttonClassName: buttonClassName,
          buttonActiveClassName: buttonActiveClassName,
          name: name,
          onClick: function onClick(event) {
            if (!_disabled && (0, _spauiUtils.isFunction)(onChange) && !unChange) {
              onChange(event, name);
            }

            if ((0, _spauiUtils.isFunction)(_onClick)) {
              _onClick(event);
            }
          }
        }), tab));
      }), addon, typeof value !== 'undefined' && needSlider && !stacked ? _react["default"].createElement("li", {
        className: "spaui-tabs-indicator",
        style: {
          visibility: 'hidden',
          margin: '0'
        },
        ref: function ref(el) {
          _this5.slider = el;
        }
      }) : null);
    }
  }, {
    key: "getCommon",
    value: function getCommon() {
      var _this$props4 = this.props,
          TabCommonComponent = _this$props4.TabCommonComponent,
          disabled = _this$props4.disabled,
          needSlider = _this$props4.needSlider,
          value = _this$props4.value,
          stacked = _this$props4.stacked,
          children = _this$props4.children;

      var filter = function filter() {
        var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        var isOk = false;

        if (item) {
          var _item$type2 = item.type,
              type = _item$type2 === void 0 ? null : _item$type2,
              _item$props4 = item.props,
              props = _item$props4 === void 0 ? {} : _item$props4;
          var _props$isTabCommon2 = props.isTabCommon,
              isTabCommon = _props$isTabCommon2 === void 0 ? false : _props$isTabCommon2,
              _children2 = props.children;

          if (type && isTabCommon && _children2) {
            isOk = true;
          }
        }

        return isOk;
      };

      var result = null;

      if (typeof TabCommonComponent !== 'undefined') {
        if ((0, _spauiUtils.isReactNode)(TabCommonComponent)) {
          result = TabCommonComponent;
        } else {
          result = _react["default"].createElement(TabCommonComponent, _extends({}, this.props, {
            disabled: disabled,
            needSlider: needSlider,
            stacked: stacked,
            value: value
          }));
        }
      } else {
        if ((0, _spauiUtils.isArray)(children)) {
          children.map(function () {
            var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            if (filter(item)) {
              if (!result) {
                result = [];
              }

              result.push(item.props.children);
            }

            return item;
          });
        } else if (filter(children)) {
          result = children.props.children;
        }
      }

      return result;
    }
  }, {
    key: "getStyles",
    value: function getStyles() {
      var _removeUndefined;

      var _this$props5 = this.props,
          navGap = _this$props5.navGap,
          navBorder = _this$props5.navBorder,
          buttonColor = _this$props5.buttonColor,
          buttonActiveColor = _this$props5.buttonActiveColor,
          buttonBg = _this$props5.buttonBg,
          buttonActiveBg = _this$props5.buttonActiveBg,
          buttonPadding = _this$props5.buttonPadding,
          buttonBorder = _this$props5.buttonBorder,
          buttonRadius = _this$props5.buttonRadius,
          buttonActiveBorder = _this$props5.buttonActiveBorder,
          indicatorColor = _this$props5.indicatorColor,
          indicatorWidth = _this$props5.indicatorWidth,
          indicatorHeight = _this$props5.indicatorHeight,
          indicatorRadius = _this$props5.indicatorRadius;
      var ret = (0, _spauiUtils.removeUndefined)((_removeUndefined = {}, _defineProperty(_removeUndefined, '--tabs-indicator-height', (0, _spauiUtils.pxVal)(indicatorHeight)), _defineProperty(_removeUndefined, '--tabs-indicator-width', (0, _spauiUtils.pxVal)(indicatorWidth)), _defineProperty(_removeUndefined, '--tabs-indicator-color', indicatorColor), _defineProperty(_removeUndefined, '--tabs-indicator-radius', (0, _spauiUtils.pxVal)(indicatorRadius)), _defineProperty(_removeUndefined, '--tabs-nav-color', buttonColor), _defineProperty(_removeUndefined, '--tabs-nav-active-color', buttonActiveColor), _defineProperty(_removeUndefined, '--tabs-nav-border', navBorder), _defineProperty(_removeUndefined, '--tabs-nav-gap', (0, _spauiUtils.pxVal)(navGap)), _defineProperty(_removeUndefined, '--tabs-nav-button-border', buttonBorder), _defineProperty(_removeUndefined, '--tabs-nav-button-active-border', buttonActiveBorder), _defineProperty(_removeUndefined, '--tabs-nav-button-radius', (0, _spauiUtils.pxVal)(buttonRadius)), _defineProperty(_removeUndefined, '--tabs-nav-button-padding', buttonPadding), _defineProperty(_removeUndefined, '--tabs-nav-button-bg', buttonBg), _defineProperty(_removeUndefined, '--tabs-nav-button-active-bg', buttonActiveBg), _removeUndefined));
      return ret;
    }
  }, {
    key: "render",
    value: function render() {
      var _this6 = this;

      var _this$props6 = this.props,
          _this$props6$tabButto = _this$props6.tabButtonWrapClassName,
          tabButtonWrapClassName = _this$props6$tabButto === void 0 ? '' : _this$props6$tabButto,
          _this$props6$tabConte = _this$props6.tabContentWrapClassName,
          tabContentWrapClassName = _this$props6$tabConte === void 0 ? '' : _this$props6$tabConte,
          _this$props6$tabPanel = _this$props6.tabPanelInnerClassName,
          tabPanelInnerClassName = _this$props6$tabPanel === void 0 ? '' : _this$props6$tabPanel,
          _this$props6$unmountI = _this$props6.unmountInactivePanel,
          unmountInactivePanel = _this$props6$unmountI === void 0 ? false : _this$props6$unmountI,
          _this$props6$tabButto2 = _this$props6.tabButtonWrapStyle,
          tabButtonWrapStyle = _this$props6$tabButto2 === void 0 ? {} : _this$props6$tabButto2,
          _this$props6$tabConte2 = _this$props6.tabContentWrapStyle,
          tabContentWrapStyle = _this$props6$tabConte2 === void 0 ? {} : _this$props6$tabConte2,
          _this$props6$commonPo = _this$props6.commonPosition,
          commonPosition = _this$props6$commonPo === void 0 ? '' : _this$props6$commonPo,
          frontOfHeadContent = _this$props6.frontOfHeadContent,
          endOfHeadContent = _this$props6.endOfHeadContent,
          frontOfBodyContent = _this$props6.frontOfBodyContent,
          endOfBodyContent = _this$props6.endOfBodyContent,
          frontOfTabsContent = _this$props6.frontOfTabsContent,
          endOfTabsContent = _this$props6.endOfTabsContent,
          stacked = _this$props6.stacked,
          needSlider = _this$props6.needSlider,
          tabButtonClassName = _this$props6.tabButtonClassName,
          defaultTabButtonClassName = _this$props6.defaultTabButtonClassName,
          useNewUI = _this$props6.useNewUI,
          style = _this$props6.style;
      var _this$props7 = this.props,
          propsValue = _this$props7.value,
          data = _this$props7.data;
      var result = this.getPanel();
      var value = "".concat(propsValue);
      var commonElement = this.getCommon();
      var showBody = true; // 如果设置了data要看下data中是否需要面板内容

      if ((0, _spauiUtils.isArray)(data)) {
        showBody = false;
        data.forEach(function (item) {
          if (item && typeof item.children !== 'undefined') {
            showBody = true;
          }
        });
      }

      var valStyle = (0, _spauiUtils.removeUndefined)(this.getStyles());
      var isRow = !stacked && defaultTabButtonClassName;
      var buttonsClassName = (0, _classnames["default"])(tabButtonClassName, {
        'with-indicator': needSlider && isRow,
        'spaui-tabs-nav': isRow && !useNewUI,
        'spaui-tabs-stacked': stacked && defaultTabButtonClassName,
        'spaui-tabs-flex': useNewUI
      }, !needSlider && useNewUI ? 'no-slider' : '');
      return _react["default"].createElement("div", _extends({}, (0, _spauiUtils.globalProps)(this.props, {
        className: 'spaui-tabs'
      }, Tabs, this.props), {
        style: _objectSpread({}, valStyle, {}, style)
      }), frontOfTabsContent, commonPosition === 'frontOfTabs' ? commonElement : null, _react["default"].createElement("div", {
        className: (0, _classnames["default"])(tabButtonWrapClassName, 'spaui-tabs-head'),
        style: tabButtonWrapStyle
      }, frontOfHeadContent, commonPosition === 'frontOfHead' ? commonElement : null, this.getButtons(buttonsClassName), endOfHeadContent, commonPosition === 'endOfHead' ? commonElement : null), showBody ? _react["default"].createElement("div", {
        className: (0, _classnames["default"])(tabContentWrapClassName, 'spaui-tabs-body'),
        style: tabContentWrapStyle
      }, frontOfBodyContent, commonPosition === 'frontOfBody' ? commonElement : null, result.map(function () {
        var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var index = arguments.length > 1 ? arguments[1] : undefined;
        var _item$props5 = item.props,
            props = _item$props5 === void 0 ? {} : _item$props5;
        var propsName = props.name,
            children = props.children;
        var name = "".concat(propsName);
        var style = {
          display: 'none'
        };
        var unmount = true;

        if (name && name === value) {
          _this6.active[name] = true;
          style.display = '';
          unmount = false;
        } // 是否卸载处于非激活的面板


        if (unmountInactivePanel && unmount) {
          return null;
        }

        return _react["default"].createElement("div", {
          key: name + index,
          style: style,
          className: tabPanelInnerClassName
        }, children);
      }), endOfBodyContent, commonPosition === 'endOfBody' ? commonElement : null) : null, endOfTabsContent, commonPosition === 'endOfTabs' ? commonElement : null);
    }
  }]);

  return Tabs;
}(_react.PureComponent); // 组件标记


_defineProperty(Tabs, "propTypes", _tabs_props.propTypes);

_defineProperty(Tabs, "defaultProps", _tabs_props.defaultProps);

(0, _spauiUtils.setComponentMark)(Tabs, _info["default"]); // 组件上报

(0, _spauiUtils.reportComponentUsage)(_objectSpread({
  scope: 'spaui'
}, _info["default"])); // 用于 focus 样式只在键盘索引时生效，而在鼠标操作时不生效

(0, _spauiUtils.initFocusManager)('spaui-focus-disabled');
var _default = Tabs;
exports["default"] = _default;